import { render, staticRenderFns } from "./dialogAnnounce.vue?vue&type=template&id=3cfb5ee5&"
import script from "./dialogAnnounce.vue?vue&type=script&lang=js&"
export * from "./dialogAnnounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports